/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { IconDownload, IconEye, IconPlus, IconSearch, IconX, IconUpload } from "@tabler/icons-react";
import ToggleButton from "../../../components/ToggleButton";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import AddOutSourceModal from "./AddOutSourceModal";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { T, useLanguage } from "../../../context/LanguageContext";
import {
  useFetchOutSourcesData,
  useOutSourceCreateMutation,
  useUpdateOutSourceStatus,
} from "../../../apis/outSourceApis";
import toast from "react-hot-toast";
import MessageModal from "../../../components/MessageModal";
import NewCommonModal from "../../../components/common/NewCommonModal";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import NoDataFound from "../../../components/common/NoDataFound";
import { useSelector } from "react-redux";
import EntriesSelector from "../../../components/common/EntriesSelector";
import useDebounce from "../../../utilities/useDebounce";
import * as XLSX from "xlsx";
import { utils, writeFile } from "xlsx";
import { handleDownload } from "../../../utilities/downloadHelper";
import { usePermission } from "../../../hooks/usePermissionTabs";
import GridView from "../../../components/common/GridView";
import ViewOutSourceModal from "./ViewOutSourceModal";

type OutsourceData = {
  id: string;
  companyName: string;
  mobileNo: string;
  email: string;
  address: string;
  vatNumber: string;
  crNumber: string;
  serviceAreaCoverage: string;
  billingCycle: string;
  primaryContactName: string;
  primaryContactNumber: string;
  primaryEmailAddress: string;
  warehouseId: string;
  cityId?: string;
  specialization?: string;
  contactPersonName: string;
};

type FormValues = {
  companyName: string;
  mobileNo: string;
  email: string;
  address: string;
  vatNumber: string;
  vatDoc: File;
  crNumber: string;
  crDoc: File;
  serviceAreaCoverage: string;
  contractStartDate: Date;
  contractEndDate?: Date;
  billingCycle: string;
  contractDoc: File;
  primaryContactName: string;
  primaryContactNumber: string;
  primaryEmailAddress: string;
  warehouseId: string;
  cityId?: string;
  specialization?: string;
  companyLogo: File;
  contactPersonName: string;
};

export default function OutSourceManagement({
  setHeaderActions,
  setHeaderButtons,
}: {
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
}) {
  const { t } = useLanguage();
  const [credential, setCredential] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState(false);

  const [viewOutSourceModal, setViewOutSourceModal] = useState(false);
  const [selectedOutSourceId, setSelectedOutSourceId] = useState<string | null>(
    null,
  );

  // const credentialToggleModal = () => {
  //   setCredential(!credential);
  // };

  const credentialToggleModal = () => {
    setCredential(!credential);
    if (!credential) return; // opening → do nothing
    reset();
    clearErrors();
    setSelectedDocument({
      vatDoc: false,
      crDoc: false,
      contractDoc: false,
      companyLogo: false,
    });
  };


  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const { mutate: updateOutSourceStatus, isPending: activePending } =
    useUpdateOutSourceStatus();
  const [searchFor, setSearchFor] = useState<any>("");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [allSelectedData, setAllSelectedData] = useState<OutsourceData[]>([]);
  const [showCheckboxes, setShowCheckboxes] = useState<boolean>(false);

  const {
    isSuccess,
    isPending: listPending,
    isFetching,
    refetch: fetchData,
  } = useFetchOutSourcesData(pageNo, limit, searchFor);

  const data = useSelector((state: any) => state?.outSource.data);

  // Calculate outsource statistics dynamically
  const outsourceStats = {
    total: data?.total || 0,
    active:
      data?.outSources?.filter((o: any) => o?.status === true).length || 0,
    inactive:
      data?.outSources?.filter((o: any) => o?.status === false).length || 0,
  };

  useEffect(() => {
    fetchData();
  }, []);
  const { mutate, isPending } = useOutSourceCreateMutation();

  const [selectedDocument, setSelectedDocument] = useState<any>({
    vatDoc: false,
    crDoc: false,
    contractDoc: false,
    companyLogo: false,
  });

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const { allowed: canCreateOutSource, isLoading } = usePermission(
    "out_source",
    "create",
  );
  const { allowed: canUpdateOutSource } = usePermission("out_source", "update");
  const { allowed: canDeleteOutSource } = usePermission("out_source", "delete");

  useEffect(() => {
    if (data?.outSources) {
      setAllSelectedData((prev) => {
        const filteredPrev = prev.filter((item: any) =>
          selectedRows.includes(item.id),
        );
        const newSelected = data.outSources.filter(
          (s: any) =>
            selectedRows.includes(s.id) &&
            !filteredPrev.some((item) => item.id === s.id),
        );
        return [...filteredPrev, ...newSelected];
      });
    }
  }, [data?.outSources, selectedRows]);

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    fetchData();
  }, [debouncedSearchFor, pageNo, limit]);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>();

  const handleCreateOutSource = (data: any) => {
    mutate(
      { ...data },
      {
        onSuccess: (data) => {
          fetchData();
          credentialToggleModal();
          reset();
          toast.success("Outsource Added Successfully.");
        },
        onError: (error) => {
          console.log(error, "error");
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            (typeof error === "string" ? error : null) ||
            "Something went wrong";

          toast.error(errorMessage);
        },
      },
    );
  };

  const handleStatusChange = (outSourceId: string, newStatus: boolean) => {
    if (!canUpdateOutSource) {
      toast.error("You do not have permission to update out source status");
      return;
    }
    updateOutSourceStatus(
      { id: outSourceId, status: newStatus },
      {
        onSuccess: () => {
          fetchData();
        },
        onError: (error: any) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
  };
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean | string>(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [columnsData, setColumnsData] = useState([
    { text: "Checkbox", value: "checkbox", isShow: showCheckboxes },
    { text: "S/N", value: "sn", isShow: true },
    { text: "Company Name", value: "companyName", isShow: true },
    { text: "Contact Person", value: "contactPerson", isShow: true },
    { text: "Mobile", value: "mobile", isShow: true },
    { text: "Email Address", value: "email", isShow: true },
    { text: "Address", value: "address", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };


  // Render stats capsule in the top-right page header
  useEffect(() => {
    if (!setHeaderButtons) return;

    setHeaderButtons(
      <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm px-4 py-1.5 rounded-xl border border-slate-200 shadow-sm text-[11px] select-none font-bold min-h-8">
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Total</T>:</span>
          <span className="text-blue-700 bg-blue-50 border border-blue-100 px-1.5 py-0.5 rounded">{outsourceStats.total}</span>
        </div>
        <span className="h-3 w-px bg-slate-300" />
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Active</T>:</span>
          <span className="text-emerald-700 bg-emerald-50 border border-emerald-100 px-1.5 py-0.5 rounded">{outsourceStats.active}</span>
        </div>
        <span className="h-3 w-px bg-slate-300" />
        <div className="flex items-center gap-1.5">
          <span className="text-slate-500"><T>Inactive</T>:</span>
          <span className="text-rose-700 bg-rose-50 border border-rose-100 px-1.5 py-0.5 rounded">{outsourceStats.inactive}</span>
        </div>
      </div>
    );

    return () => {
      setHeaderButtons(null);
    };
  }, [setHeaderButtons, outsourceStats.total, outsourceStats.active, outsourceStats.inactive]);

  const handleSelectRow = (id: string) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data?.outSources?.length) {
      setSelectedRows((prev) =>
        prev.filter((id) => !data.outSources.some((c: any) => c.id === id)),
      );
    } else {
      const newSelections =
        data?.outSources
          ?.filter((c: any) => !selectedRows.includes(c.id))
          .map((c: any) => c.id) || [];
      setSelectedRows((prev) => [...prev, ...newSelections]);
    }
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "checkbox":
          return {
            label: (
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={
                    data?.outSources?.length > 0 &&
                    data?.outSources?.every((c: any) =>
                      selectedRows.includes(c.id),
                    )
                  }
                  onChange={handleSelectAll}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                 bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                  top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
            ),
            render: (c: any) => (
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={selectedRows.includes(c.id)}
                  onChange={() => handleSelectRow(c.id)}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                  bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
            ),
          };
        case "sn":
          return {
            label: "#",
            render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
          };
        case "companyName":
          return {
            label: "Company Name",
            render: (c: any) => (
              <div className="flex items-center gap-2 truncate max-w-xs">
                <span className="truncate">{c.companyName}</span>
              </div>
            ),
          };

        case "contactPerson":
          return {
            label: "Contact Person",
            render: (c: any) => c.contactPersonName,
          };
        case "mobile":
          return { label: "Mobile", render: (c: any) => c.mobileNo };
        case "email":
          return { label: "Email Address", render: (c: any) => c.email };
        case "address":
          return { label: "Address", render: (c: any) => c.address };
        case "status":
          return {
            label: "Status",
            render: (c: any) => (
              <div className="flex justify-center">
                <ToggleButton
                  onChange={() => {
                    handleStatusChange(c?.id, !c.status);
                  }}
                  checked={c.status}
                />
              </div>
            ),
          };
        case "actions":
          return {
            label: "Actions",
            render: (c: any) => (
              <div className="text-center">
                <button
                  onClick={() => {
                    window.dispatchEvent(
                      new CustomEvent("openOutSourceModal", {
                        detail: { outSourceId: c.id },
                      }),
                    );
                  }}
                  className="p-2 border rounded-full bg-[#F7F6F2]"
                >
                  <IconEye size={22} />
                </button>
              </div>
            ),
          };
        default:
          return { label: "", render: () => null };
      }
    });

  const mapDataToExport = (c: any, index: number) => ({
    "S/N": index + 1,
    "Company Name": c.companyName || c.companyName,
    "Contact Person": c.contactPersonName,
    Mobile: c.mobileNo,
    Email: c.email,
    Address: c.address,
    Status: c.status,
  });

  return (
    <>
   <div className="">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          {/* Left side: Brand badge */}
          <div className="flex flex-wrap items-center gap-3">
            
          </div>

          {/* Right side: Search + Export + Entries + Stats capsule */}
          <div className="flex items-center flex-wrap gap-2.5">
            {/* Sliding Search */}
            <div className="relative flex items-center">
              <div
                onClick={() => { if (!showSearch) setShowSearch(true); }}
                className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-md bg-white shadow-sm h-8 ${showSearch ? "w-64 px-2 cursor-default" : "w-8 justify-center cursor-pointer"
                  }`}
              >
                <button
                  onClick={(e) => { e.stopPropagation(); setShowSearch(!showSearch); }}
                  className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                  title="Search"
                >
                  <IconSearch size={17} stroke={2.5} />
                </button>
                {showSearch && (
                  <>
                    <input
                      type="text"
                      value={searchFor}
                      onChange={(e) => { setSearchFor(e.target.value); setPageNo(1); }}
                      placeholder={t("Search...")}
                      autoFocus
                      className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none focus:outline-none focus:ring-0"
                    />
                    <button
                      onClick={(e) => { e.stopPropagation(); setSearchFor(""); setShowSearch(false); setPageNo(1); }}
                      className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                      title="Clear & Close"
                    >
                      <IconX size={14} stroke={2.5} />
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Export to Excel */}
            <button
              onClick={() =>
                handleDownload({
                  selectedRows,
                  allSelectedData,
                  setSelectedRows,
                  setAllSelectedData,
                  showCheckboxes,
                  setShowCheckboxes,
                  setColumnsData,
                  mapDataToExport,
                  fileName: "outSource_management.xlsx",
                })
              }
              className={`flex items-center justify-center h-8 border border-slate-200 text-slate-700 rounded-md transition shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150 ${showCheckboxes && selectedRows.length === 0 ? "bg-white/50 text-slate-400" : "bg-white hover:bg-slate-50"
                } ${selectedRows.length > 0 ? "px-3" : "w-8"}`}
              title="Export to Excel"
            >
              <IconDownload size={17} stroke={2.5} />
              {selectedRows.length > 0 && <span className="font-bold text-xs ml-1">({selectedRows.length})</span>}
            </button>

            {data && data.totalPages * limit > 10 && (
              <EntriesSelector
                value={limit}
                options={[
                  10,
                  ...(data.totalPages * limit > 10 ? [20] : []),
                  ...(data.totalPages * limit > 20 ? [30] : []),
                  ...(data.totalPages * limit > 50 ? [50] : []),
                  ...(data.totalPages * limit > 100 ? [100] : []),
                ]}
                onChange={(val) => { setLimit(val); setPageNo(1); setSelectedRows([]); setAllSelectedData([]); }}
              />
            )}


            {/* Add + Bulk Upload buttons */}
            {canCreateOutSource && (
              <>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent("openAddOutSourceModal"))}
                  className="flex items-center justify-center p-2 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-xl transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
                  title="Add Company"
                >
                  <IconPlus size={17} stroke={2.5} />
                </button>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent("openOutSourceBulkUploadModal"))}
                  className="flex items-center justify-center p-2 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-xl transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 duration-150"
                  title="Bulk Upload"
                >
                  <IconUpload size={17} stroke={2.5} />
                </button>
              </>
            )}
          </div>
        </div>

        <div className="py-4">
          {data?.outSources && data.outSources.length > 0 ? (
            <GridView
              columns={5}
              className=" grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
              data={data?.outSources}
              renderItem={(outSources: any) => (
                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  {/* Header */}
                  <div className="flex items-start justify-between border-b border-[#D2D2D2]/70">
                    <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                    <div>
                      <h3 className="text-[#000000] font-semibold text-lg line-clamp-1">
                        {outSources.companyName}
                      </h3>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleStatusChange(outSources?.id, !outSources.status);
                      }}
                      className={`px-3 py-1 rounded-full text-xs font-medium cursor-pointer capitalize ${outSources.status
                        ? "bg-green-500/15 text-green-400"
                        : "bg-red-500/15 text-red-400"
                        }`}
                    >
                      <T>{outSources.status ? "Active" : "Inactive"}</T>
                    </button>
                  </div>

                  <div className="space-y-3">
                    {/* Role */}

                    {/* Phone */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Phone</T>:</span>
                      <span className="text-[#212121] text-sm font-medium">
                        {outSources.mobileNo}
                      </span>
                    </div>

                    {/* Email */}
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Email</T>:</span>
                      <span
                        className="text-[#212121] text-sm font-medium truncate max-w-[160px]"
                        title={outSources.email}
                      >
                        {outSources.email}
                      </span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-[#212121] text-sm"><T>Address</T> :</span>
                      <span className="text-[#212121] text-sm font-medium truncate max-w-[160px]" title={outSources.address}>
                        {outSources.address}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      className="flex-1 h-10 rounded-lg bg-[#FBD037]/20  text-[#000000] text-sm font-medium "
                      onClick={() => {
                        window.dispatchEvent(
                          new CustomEvent("openOutSourceModal", {
                            detail: { outSourceId: outSources.id },
                          }),
                        );
                      }}
                    >
                      <T>View Profile</T>
                    </button>
                  </div>
                </div>
              )}
            />
          ) : (
            <NoDataFound />
          )}
          <div className="pt-4 flex justify-center">
            {data?.totalPages > 1 && (
              <Pagination
                currentPage={pageNo}
                totalPages={data.totalPages}
                fetchData={handlePaginationFetch}
              />
            )}
          </div>
        </div>

        {/* <div className="">
          {isFetching || listPending ? (
            <TableSkeleton
              columns={columnsData.filter((c) => c.isShow).map((c) => c.text)}
              rows={6}
            />
          ) : data?.outSources && data.outSources.length > 0 ? (
            <ListView
              data={data.outSources}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={columns}
            />
          ) : (
            <NoDataFound />
          )}
        </div> */}
      </div>








    </>
  );
}

